<template>

  <div>
    
    <div v-if="permissions.includes('manage_candidates')">
      
      <div
        v-if="!selectedJob"
        class="alert alert-warning">
        {{ $t('To send an email, select a job') }}
      </div>

      <div
        v-if="!candidate.email"
        class="alert alert-warning">
        O candidato não possui e-mail
      </div>

      <div
        v-if="selectedJob && candidate.email"
        class="card">
        <div class="card-body">
          <EmailForm
            :initValue="{candidate_id: candidate._id, job_id: selectedJob._id, to: [{name: candidate.name, email: candidate.email}]}"
            @created="created" />
        </div>
      </div>
    </div>

    <CandidateFeed :activityType="'email'" />

  </div>

</template>

<script>
import EmailForm from '@/components/Email/EmailForm'
import CandidateFeed from '../Feed/CandidateFeed'

export default {
  name: 'CandidateEmail',
  components: {
    EmailForm,
    CandidateFeed
  },
  data () {
    return {
    }
  },
  computed: {
    permissions () {
      return this.$store.getters.getPermissions
    },
    candidate () {
      return this.$store.getters.getCandidate
    },
    selectedJob () {
      return this.$store.getters.getCandidateSelectedJob
    }
  },
  created () {
  },
  methods: {
    created (email) {
      return this.$store.dispatch('refreshSelectActivities')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Candidate/Email/CandidateEmail.vue